import template from './dateTimeRangePicker.modal.component.html';

/* @ngInject */
function DateTimeRangePickerModalController() {
  const vm = this;
  vm.$onInit = $onInit;

  function $onInit() {
    vm.start = vm.resolve.start;
    vm.end = vm.resolve.end;
  }

  vm.done = () => {
    vm.close({
      $value: {
        start: vm.start,
        end: vm.end
      }
    });
    vm.showDateRangeSelector = !vm.showDateRangeSelector;
  };
  vm.cancel = () => {
    vm.dismiss();
  };

}


export default {
  name: 'dateTimeRangePickerModal',
  template,
  controller: DateTimeRangePickerModalController,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&'
  }
};
